<template>
  <div class="min-h-screen bg-gray-900 flex items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8 bg-gray-800 p-10 rounded-2xl shadow-2xl border border-red-500/30">
      <div>
        <div class="mx-auto h-24 w-24 flex items-center justify-center rounded-full bg-red-900/20 border-2 border-red-500 mb-6">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m0 0v2m0-2h2m-2 0H10m11 3.342a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h4l2-2h4l2 2h4a2 2 0 012 2v10.342z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 0h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 13c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-white">
          Acceso Restringido
        </h2>
        <p class="mt-4 text-center text-sm text-gray-400">
          Su mensualidad ha expirado o su licencia se encuentra inactiva.
        </p>
      </div>

      <div class="mt-8 space-y-6">
        <div class="rounded-md bg-red-900/10 p-4 border border-red-900/30">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-red-400">
                Sistema bloqueado
              </h3>
              <div class="mt-2 text-sm text-red-300/70">
                <p>
                  Para reactivar el acceso, por favor contacte al administrador del sistema.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center space-y-4">
          <p class="text-gray-300 font-medium">JeanInformática CA</p>
          <div class="flex items-center justify-center space-x-2 text-blue-400">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <span class="text-lg font-bold">584167170715</span>
          </div>
        </div>

        <div class="pt-4 space-y-3">
          <button @click="reintentar" class="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-xl text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200 shadow-lg shadow-indigo-500/20">
            Reintentar Acceso
          </button>
          
          <router-link to="/login" class="w-full flex justify-center py-2 px-4 text-sm font-medium text-gray-400 hover:text-white transition-colors">
            Acceso Super Administrador
          </router-link>
        </div>
      </div>
      
      <div class="mt-6 text-center">
        <p class="text-xs text-gray-500">
          ID del Dispositivo: <span class="font-mono">{{ deviceId }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const deviceId = ref('JEAN-INFO-' + Math.random().toString(36).substring(2, 10).toUpperCase());

const reintentar = () => {
  window.location.href = '/';
};

onMounted(() => {
  // Ocultar cualquier sidebar o nav si existe
  document.querySelectorAll('.sidebar, .navbar').forEach(el => el.style.display = 'none');
});
</script>

<style scoped>
/* Estilos adicionales si son necesarios */
</style>
